import { useState, useEffect } from 'react';

export const usePerformance = () => {
  const [isLowPerformance, setIsLowPerformance] = useState(false);
  const [isReducedMotion, setIsReducedMotion] = useState(false);

  useEffect(() => {
    // Detectar preferencia de movimiento reducido
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setIsReducedMotion(mediaQuery.matches);

    const handleReducedMotion = (e) => setIsReducedMotion(e.matches);
    mediaQuery.addEventListener('change', handleReducedMotion);

    // Detectar rendimiento del dispositivo
    const detectPerformance = () => {
      const start = performance.now();
      
      // Test simple de rendimiento
      let result = 0;
      for (let i = 0; i < 1000000; i++) {
        result += Math.random();
      }
      
      const end = performance.now();
      const duration = end - start;
      
      // Si toma más de 50ms, considerar dispositivo lento
      const slowDevice = duration > 50;
      
      // Detectar memoria disponible
      const memoryInfo = navigator.deviceMemory || 4; // Fallback a 4GB
      const lowMemory = memoryInfo < 4;
      
      // Detectar conexión lenta
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const slowConnection = connection && (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g');
      
      setIsLowPerformance(slowDevice || lowMemory || slowConnection);
    };

    detectPerformance();

    return () => {
      mediaQuery.removeEventListener('change', handleReducedMotion);
    };
  }, []);

  return { isLowPerformance, isReducedMotion };
}; 